var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"status-lamp",style:({backgroundColor: _vm.isActive ? _vm.onColor : _vm.offColor})})}
var staticRenderFns = []

export { render, staticRenderFns }